document.addEventListener("DOMContentLoaded", function () {
	document.addEventListener('click', (e) => {
		const trigger = e.target.closest('.selected-signature');

		if (trigger) {
			const wrapper = trigger.closest('.player-sign-product-wrapper');
			const list = wrapper?.querySelector('.signature-variant-select');

			if (list) {
				document.querySelectorAll('.signature-variant-select').forEach(el => {
					if (el !== list) el.style.display = 'none';
				});
				list.style.display = list.style.display === 'block' ? 'none' : 'block';
			}

			return;
		}
		document.querySelectorAll('.signature-variant-select').forEach(el => {
			el.style.display = 'none';
		});
	});
	document.addEventListener('click', (e) => {
		const li = e.target.closest('.signature-variant-select li');
		if (!li) return;

		const wrapper = li.closest('.player-sign-product-wrapper');
		if (!wrapper) return;

		const button = wrapper.querySelector('.add-signature-product');
		if (!button) return;
		wrapper.querySelectorAll('.signature-variant-select li')
			.forEach(el => el.classList.remove('active'));
		li.classList.add('active');
		const variantId = li.dataset.value || li.getAttribute('value');
		const qtyLeft = li.dataset.value || li.getAttribute('data-inventory_quantity');
		const variantTitle = li.textContent.trim();
		button.dataset.signProductId = variantId;
		button.classList.remove('disabled');
		const list = wrapper.querySelector('.signature-variant-select');
		if (list) list.style.display = 'none';
		const selectedLabel = wrapper.querySelector('.selected-signature .selected-signature-label');
		const selectedQty = wrapper.querySelector('.signature-left-qty .signature-left-qty-data');
		if (selectedLabel) {
			selectedLabel.textContent = variantTitle;
		}
		if (selectedQty) {
			selectedQty.textContent = qtyLeft;
		}
		wrapper.classList.add('added');
	});
	// cart page signature ADD ON
	document.addEventListener('click', async (e) => {
		const btn = e.target.closest('.main-cart__wrapper .add-signature-product');
		if (!btn) return;

		if (btn.classList.contains('loading')) return;

		const wrapper = btn.closest('.player-sign-product-wrapper');
		if (!wrapper) return;

		const variantId = Number(btn.dataset.signProductId || 0);
		const lineKey = wrapper.dataset.lineKey;

		const selectedLabel = wrapper.querySelector('.selected-signature-label')?.textContent?.trim();

		if (!variantId || !lineKey) return;

		btn.classList.add('loading');
		btn.setAttribute('aria-disabled', 'true');

		try {
			let cart = await fetch('/cart.js').then(res => res.json());

			const signatureItems = cart.items.filter(
				item => item.properties?._parent_key === lineKey
			);

			const mainItem = cart.items.find(item => item.key === lineKey);
			if (!mainItem) throw new Error('Main product not found');

			if (signatureItems.length > 1) {
				const itemsToRemove = signatureItems.slice(1);

				await Promise.all(
					itemsToRemove.map(item =>
						fetch('/cart/change.js', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								id: item.key,
								quantity: 0
							})
						})
					)
				);
			}

			const existingSignature = signatureItems[0];

			// 🔥 STEP 2: Add or update signature product
			if (existingSignature) {
				await fetch('/cart/change.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						id: existingSignature.key,
						quantity: 1,
						properties: {
							...existingSignature.properties,
							_signature_variant_id: variantId,
							player_signature: selectedLabel,
							_signature_product: true
						}
					})
				});
			} else {
				const addRes = await fetch('/cart/add.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						id: variantId,
						quantity: 1,
						properties: {
							_parent_key: lineKey,
							_signature_product: true,
							_signature_variant_id: variantId,
							player_signature: selectedLabel
						}
					})
				});

				if (!addRes.ok) throw new Error('Failed to add signature product');
			}

			await new Promise(resolve => setTimeout(resolve, 150));

			const updatedCart = await fetch('/cart.js').then(res => res.json());

			const updatedMainItem = updatedCart.items.find(
				item => item.key === lineKey
			);

			if (!updatedMainItem) throw new Error('Updated main item not found');

			const cartItems = document.querySelector('cart-items');
			const sections =
				cartItems?.getSectionsToRender()?.map(s => s.section) || [];

			const response = await fetch('/cart/change.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					id: lineKey,
					properties: {
						...updatedMainItem.properties,
						_has_signature: true,
						_signature_variant_id: variantId,
						player_signature: selectedLabel,
						_parent_key: lineKey
					},
					sections: sections,
					sections_url: window.location.pathname
				})
			});

			const parsedState = await response.json();

			if (cartItems && parsedState.sections) {
				cartItems.getSectionsToRender().forEach((section) => {
					const container = document.getElementById(section.id);
					if (!container) return;

					const elementToReplace =
						container.querySelector(section.selector) || container;

					elementToReplace.innerHTML =
						cartItems.getSectionInnerHTML(
							parsedState.sections[section.section],
							section.selector
						);
				});
			} else {
				window.location.reload();
			}

			if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
				publish(PUB_SUB_EVENTS.cartUpdate, {
					source: 'signature-add'
				});
			}

		} catch (err) {
			console.error('❌ Signature add error:', err);
			window.location.reload(); // fail-safe
		} finally {
			btn.classList.remove('loading');
			btn.removeAttribute('aria-disabled');
		}
	});
	// cart drawer signature ADD ON
	document.addEventListener('click', async (e) => {
		const btn = e.target.closest('.cart-drawer .add-signature-product');
		const mainWrapper = e.target.closest('.cart-item');
		const wrapper = btn.closest('.player-sign-product-wrapper');

		const variantId = Number(btn.dataset.signProductId);
		const mainProductId = wrapper.dataset.mainProduct;
		const lineKey = wrapper.dataset.lineKey;

		const selectedLabel = wrapper.querySelector('.selected-signature')?.textContent?.trim();

		if (!variantId) return;

		btn.classList.add('loading');
		mainWrapper.classList.add('disabled');
		btn.setAttribute('aria-disabled', 'true');

		try {
			const cart = await fetch('/cart.js').then(res => res.json());
			const existingSignature = cart.items.find(
				item => item.properties && item.properties._parent_key === lineKey
			);

			const mainItem = cart.items.find(item => item.key === lineKey);

			if (existingSignature) {
				await fetch('/cart/change.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						id: existingSignature.key,
						quantity: 1,
						properties: {
							...existingSignature.properties,
							_signature_variant_id: variantId,
							player_signature: selectedLabel
						}
					})
				});
			} else {
				// ✅ Add new signature product
				const addRes = await fetch('/cart/add.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						id: variantId,
						quantity: 1,
						properties: {
							_signature_variant_id: variantId,
							_parent_key: lineKey,
							_signature_product: true,
							player_signature: selectedLabel
						}
					})
				});

				if (!addRes.ok) throw new Error('Failed to add signature product.');
			}

			// ✅ Update MAIN product (merge properties safely)
			if (mainItem) {
				await fetch('/cart/change.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						id: lineKey,
						properties: {
							...mainItem.properties,
							_has_signature: true,
							_signature_variant_id: variantId,
							player_signature: selectedLabel,
							_parent_key: lineKey
						}
					})
				});
			}

			// ✅ Refresh cart drawer
			const cartDrawerEl = document.querySelector('cart-drawer');

			if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function') {
				const cartState = await fetch(
					'/?sections=cart-drawer,cart-icon-bubble'
				).then(r => r.json());

				cartDrawerEl.renderContents({
					sections: cartState,
					id: variantId
				});
			} else {
				document.dispatchEvent(new CustomEvent('cart:refresh'));
			}

		} catch (err) {
			console.error(err);
		} finally {
			btn.classList.remove('loading');
			btn.removeAttribute('aria-disabled');
		}
	});
	//   cart drawer remove sign product
	document.addEventListener('click', async (e) => {
		const btn = e.target.closest('.cart-drawer .remove-sign-product');
		if (!btn || btn.classList.contains('loading')) return;
	
		const cartItemEl = btn.closest('.cart-item');
		if (!cartItemEl) return;
	
		cartItemEl.classList.add('disabled');
		btn.classList.add('loading');
		btn.setAttribute('aria-disabled', 'true');
	
		try {
			// 1. Get current cart state
			const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then(res => res.json());
			const lineKey = cartItemEl.dataset.lineKey;
			const mainItem = cart.items.find(item => item.key === lineKey);
	
			if (!mainItem) throw new Error('Main item not found');
	
			const parentKey = mainItem.properties?._parent_key || mainItem.properties?.parent_key;
	
			const customProduct = cart.items.find(item => 
				(item.properties?._parent_key === parentKey || item.properties?.parent_key === parentKey) && 
				item.key !== mainItem.key
			);
			const keysToRemove = ['_has_signature', '_signature_variant_id', 'player_signature', '_parent_key', 'parent_key'];
			const cleanProperties = {};
			Object.keys(mainItem.properties || {}).forEach(key => {
				if (!keysToRemove.includes(key)) {
					cleanProperties[key] = mainItem.properties[key];
				}
			});
			await fetch(`${window.Shopify.routes.root}cart/change.js`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					id: mainItem.key,
					properties: cleanProperties
				})
			});
	
			// 5. Remove the custom product and fetch fresh sections for the drawer
			const updates = {};
			if (customProduct) updates[customProduct.key] = 0;
	
			const updateResponse = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					updates: updates,
					sections: 'cart-drawer,cart-icon-bubble',
					sections_url: window.location.pathname
				})
			});
	
			const parsedState = await updateResponse.json();
	
			// 6. Refresh Cart Drawer UI
			const cartDrawerEl = document.querySelector('cart-drawer');
			if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function') {
				cartDrawerEl.renderContents(parsedState);
			} else {
				// Fallback for themes that don't use the standard renderContents
				document.dispatchEvent(new CustomEvent('cart:refresh'));
			}
	
		} catch (err) {
			console.error("Cart drawer update failed:", err);
		} finally {
			btn.classList.remove('loading');
			cartItemEl.classList.remove('disabled');
			btn.removeAttribute('aria-disabled');
		}
	});
	// //   cart page signature Remove on
	
	document.addEventListener('click', async (e) => {
		const btn = e.target.closest('.main-cart__wrapper .remove-sign-product');
		if (!btn || btn.classList.contains('loading')) return;
	
		const cartItemEl = btn.closest('.cart-item');
		if (!cartItemEl) return;
	
		cartItemEl.classList.add('disabled');
		btn.classList.add('loading');
	
		try {
			// 1. Get current cart state
			const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then(res => res.json());
			const lineKey = cartItemEl.dataset.lineKey;
			const mainItem = cart.items.find(item => item.key === lineKey);
	
			if (!mainItem) throw new Error('Main item not found');
	
			const parentKey = mainItem.properties?._parent_key;
	
			// 2. Identify the custom product to remove (but NOT the app product)
			const customProduct = cart.items.find(item => 
				item.properties?._parent_key === parentKey && item.key !== mainItem.key
			);
	
			const keysToRemove = ['_has_signature', '_signature_variant_id', 'player_signature', '_parent_key'];
			const cleanProperties = {};
			Object.keys(mainItem.properties || {}).forEach(key => {
				if (!keysToRemove.includes(key)) {
					cleanProperties[key] = mainItem.properties[key];
				}
			});
			const updates = {};
			if (customProduct) updates[customProduct.key] = 0;
	
			
			await fetch(`${window.Shopify.routes.root}cart/change.js`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					id: mainItem.key,
					properties: cleanProperties
				})
			});
	
			// 5. Now remove the custom product and get fresh sections
			const cartItems = document.querySelector('cart-items');
			const sectionIds = cartItems?.getSectionsToRender?.().map(s => s.section) || [];
	
			const updateResponse = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					updates: updates,
					sections: sectionIds,
					sections_url: window.location.pathname
				})
			});
	
			const parsedState = await updateResponse.json();
	
			// 6. Update UI
			if (parsedState.sections && cartItems) {
				cartItems.getSectionsToRender().forEach((section) => {
					const container = document.getElementById(section.id);
					const elementToReplace = container?.querySelector(section.selector) || container;
					if (elementToReplace) {
						elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
							parsedState.sections[section.section],
							section.selector
						);
					}
				});
			} else {
				document.dispatchEvent(new CustomEvent('cart:refresh'));
			}
	
		} catch (err) {
			console.error("Update failed:", err);
		} finally {
			btn.classList.remove('loading');
			cartItemEl.classList.remove('disabled');
		}
	});

	document.addEventListener("click", (e) => {
		const yesBtn = e.target.closest(".yesBtn");
		const noBtn = e.target.closest(".noBtn");
		const buttonGroup = e.target.closest(".btn-group");
	  
		if (!yesBtn && !noBtn) return;
	  
		// 🔥 get closest parent wrapper
		const wrapper = e.target.closest(".player-sign-product-wrapper");
		if (!wrapper) return;
	  
		const blocks = wrapper.querySelectorAll(".details-hidden");
		const yes = wrapper.querySelector(".yesBtn");
		const no = wrapper.querySelector(".noBtn");
	  
		// if (yesBtn) {
		//   yes.classList.remove("button--tertiary");
		//   blocks.forEach(block => {
		// 	block.style.display = "inline-flex";
		//   });
		//   if (buttonGroup) buttonGroup.style.display = "none";
		// }
	  
		if (noBtn) {
		  if (wrapper) wrapper.style.display = "none";
		}
	});
});